import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./view-application-adhoc.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./view-application-adhoc.component.scss?ngResource";
import { ChangeDetectionStrategy, Component } from "@angular/core";
import { ViewApplicationConstants } from "../shared/view-application.constants";
import { ViewApplicationAdhocFeedbackComponent } from "../view-application-adhoc-feedback/view-application-adhoc-feedback.component";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import * as ViewApplicationFeedbackConstants from "../view-application-adhoc-feedback/view-application-adhoc-feedback.constants";
import html2canvas from "html2canvas";
import * as FeedbackDetailsConstants from "../feedback-details/feedback-details.constants";
import { SharedConstants } from "../../../shared/constants/shared.constants";
import { AlertType } from "../../../shared/models/alert";
import { CRUDOperation } from "../../../shared/models/crud-operation-enum.model";
import { AppControllerService } from "../../../app-controller.service";
import { ApplicationService } from "../shared/application.service";
import { RequestStatusService } from "../../../shared/services/request-status/request-status.service";
import { BuildInformationComponent } from "../view-application-adhoc-buildinfo/view-application-adhoc-buildinfo.component";
import { AppConfig } from "../../../app.config";
import { Clipboard } from "@angular/cdk/clipboard";
import { ERROR_TEXT, SUCCESS_TEXT } from "./view-application-adhoc.constants";
import { AutoUnsub } from "../../../shared/decorators/autounsub.decorator";
import { PopUpComponent } from "../../../shared/components/pop-up/pop-up.component";
let ViewApplicationAdhocComponent = class ViewApplicationAdhocComponent {
    clipboard;
    modalService;
    appController;
    applicationService;
    requestStatusService;
    dialogTitle = ViewApplicationFeedbackConstants.TITLE_TEXT;
    feedbackText = ViewApplicationConstants.SEND_US_FEEDBACK_LINK_TEXT;
    buildText = ViewApplicationConstants.BUILD_INFO_LINK_TEXT;
    shareText = ViewApplicationConstants.SHARE_LINK_TEXT;
    adHocLinks;
    applicationVersionText;
    feedbackProperties = FeedbackDetailsConstants.FEEDBACK_PROPERTIES;
    fileType = FeedbackDetailsConstants.FILE_TYPE;
    modalBodyOptions = {
        size: "lg",
        centered: true,
        backdrop: "static"
    };
    dateString = "";
    file = null;
    formData;
    apiVersion;
    getAssemblyVersionSubscription;
    submitAdhocFeedbackRequestSubscription;
    constructor(clipboard, modalService, appController, applicationService, requestStatusService) {
        this.clipboard = clipboard;
        this.modalService = modalService;
        this.appController = appController;
        this.applicationService = applicationService;
        this.requestStatusService = requestStatusService;
    }
    ngOnInit() {
        this.adHocLinks = new Array();
    }
    btnShareClicked() {
        const shareUrl = window.location.href;
        const isCopied = this.clipboard.copy(shareUrl);
        const dialogRef = this.modalService.open(PopUpComponent, this.modalBodyOptions);
        if (isCopied) {
            dialogRef.componentInstance.title = ViewApplicationConstants.SHARE_LINK_TEXT;
            dialogRef.componentInstance.contentMessage = SUCCESS_TEXT;
            dialogRef.componentInstance.updateBtnPlaceholder = SharedConstants.CLOSE_LABEL;
            dialogRef.componentInstance.hideCancelBtn = true;
        }
        else {
            dialogRef.componentInstance.title = ViewApplicationConstants.SHARE_LINK_TEXT;
            dialogRef.componentInstance.contentMessage = ERROR_TEXT;
            dialogRef.componentInstance.updateBtnPlaceholder = SharedConstants.CLOSE_LABEL;
            dialogRef.componentInstance.hideCancelBtn = true;
        }
    }
    btnFeedbackClicked() {
        this.requestStatusService.showBusySpinner("prepareScreenShot");
        html2canvas(document.body).then(canvas => {
            canvas.toBlob(blob => {
                const currentDate = new Date();
                this.dateString = `${currentDate.getDate()}.${currentDate.getMonth() + 1}.${currentDate.getFullYear()} - ${currentDate.getHours()}.${currentDate.getMinutes()}.png`;
                this.file = new File([blob], this.dateString, { type: this.fileType });
                this.requestStatusService.removeBusySpinner("prepareScreenShot");
                const dialogRef = this.modalService.open(ViewApplicationAdhocFeedbackComponent, this.modalBodyOptions);
                this.formData = new FormData();
                dialogRef.componentInstance.dialogTitle = this.dialogTitle;
                dialogRef.componentInstance.data = true;
                dialogRef.componentInstance.formData = this.formData;
                dialogRef.result.then((data) => {
                    if (data) {
                        if (data.sendScreenshot) {
                            data.formData.append(this.feedbackProperties.screenshot, this.file);
                        }
                        this.sendEmail(data.formData);
                    }
                });
            });
        });
    }
    btnBuildInfoClicked() {
        this.getAssemblyVersionSubscription = this.applicationService.getAssemblyVersion().subscribe({
            next: (apiVersion) => {
                this.applicationVersionText = AppConfig.settings.applicationVersion;
                this.apiVersion = apiVersion;
                const dialogRef = this.modalService.open(BuildInformationComponent, this.modalBodyOptions);
                dialogRef.componentInstance.modalTitle = "AFLA Build Information";
                dialogRef.componentInstance.applicationVersion = this.applicationVersionText;
                dialogRef.componentInstance.apiVersion = this.apiVersion;
            },
            error: (error) => {
                this.appController.handleServerErrorMessage("View-application-adhoc", error, CRUDOperation.Get);
            }
        });
    }
    sendEmail(formData) {
        this.submitAdhocFeedbackRequestSubscription = this.applicationService.submitAdhocFeedbackRequest(formData).subscribe(response => {
            this.appController.showMessage(SharedConstants.SUBMIT_SUCCESS, AlertType.Success);
        }, error => {
            this.appController.handleServerErrorMessage("View-application-adhoc", error, CRUDOperation.Add);
        });
    }
    static ctorParameters = () => [
        { type: Clipboard },
        { type: NgbModal },
        { type: AppControllerService },
        { type: ApplicationService },
        { type: RequestStatusService }
    ];
};
ViewApplicationAdhocComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-view-application-adhoc",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsub()
], ViewApplicationAdhocComponent);
export { ViewApplicationAdhocComponent };
